export enum PaymentProviderStateEnum {
  Initial,
  Ready,
  InProgress,
  Error,
  Complete,
}
